import Vue from 'vue'
import vuefire from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import router from './router'
import store, { AUTH_STATE_AUTHED, AUTH_STATE_NOAUTH, AUTH_STATE_AUTHING, ADD_GLOBAL_MESSAGE } from './store'

Vue.use(firebase)
Vue.use(vuefire)

const cfg = {
  intrivpn: {
    apiKey: 'AIzaSyDKw8JTDXCQzqpExLJIMdJ4PNTp0epNWe4',
    authDomain: 'intrivpn.firebaseapp.com',
    databaseURL: 'https://intrivpn.firebaseio.com',
    projectId: 'intrivpn',
    storageBucket: 'intrivpn.appspot.com',
    messagingSenderId: '285525753731'
  },
  testintrivpn: {
    apiKey: 'AIzaSyCqfAiLE9XkQLeXvVrH9X7QyJG4u-zr_I8',
    authDomain: 'testintrivpn.firebaseapp.com',
    databaseURL: 'https://testintrivpn.firebaseio.com',
    projectId: 'testintrivpn',
    storageBucket: 'testintrivpn.appspot.com',
    messagingSenderId: '246262938733'
  }
}

firebase.initializeApp(cfg.testintrivpn)
checkIdTokenChanged() // Start detecting IdTokenChange

export function checkIdTokenChanged () {
  firebase.auth().onIdTokenChanged(async (user) => {
    const currentRoutePath = router.currentRoute.path
    if (user) {
      const { email, emailVerified, uid } = user
      const { role } = await handleUserData('get', uid)
      store.commit(AUTH_STATE_AUTHED, { email, emailVerified, uid, role })
      /* when auth and on '/sign-in', '/sign-up', go '/' */
      if (['/sign-in', '/sign-up'].includes(currentRoutePath)) {
        router.push('/')
      }
    } else {
      store.commit(AUTH_STATE_NOAUTH)
      /* when not auth and not on '/sign-in', '/sign-up', go '/sign-in' */
      if (!['/sign-in', '/sign-up'].includes(currentRoutePath)) {
        router.push('/sign-in')
      }
    }
  })
}

export async function signIn (email, pwd, rememberMe) {
  /* authing */
  store.commit(AUTH_STATE_AUTHING)
  const persistence = rememberMe ? 'LOCAL' : 'SESSION'
  const signInReq = firebase.auth()
    .setPersistence(firebase.auth.Auth.Persistence[persistence])
    .then(() => firebase.auth().signInWithEmailAndPassword(email, pwd))
    .catch((err) => {
      // console.error('signInWithEmailAndPassword:', err)
      store.commit(AUTH_STATE_NOAUTH)
      store.commit(ADD_GLOBAL_MESSAGE, {
        type: 'danger',
        content: err.message
      })
    })
  return signInReq
}

export function signUp (email, pwd) {
  /* authing */
  store.commit(AUTH_STATE_AUTHING)
  const signUpReq = firebase.auth().createUserWithEmailAndPassword(email, pwd)
    .then(({ user }) => {
      handleUserData('set', user.uid, email)
    })
    .catch((err) => {
      // console.error('createUserWithEmailAndPassword:', err)
      store.commit(ADD_GLOBAL_MESSAGE, {
        type: 'danger',
        content: err.message
      })
    })
  return signUpReq
}

export function signOut () {
  const signOutReq = firebase.auth().signOut()
    .catch((err) => {
      // console.error('signOut:', err)
      store.commit(ADD_GLOBAL_MESSAGE, {
        type: 'danger',
        content: err.message
      })
    })
  return signOutReq
}

export function resetPassword (mail) {
  return firebase.auth().sendPasswordResetEmail(mail, {url: 'https://www.intrivpn.io'})
    .then(() => {
      store.commit(ADD_GLOBAL_MESSAGE, {
        type: 'success',
        content: 'Password reset email successfully sent'
      })
      router.push('/sign-in')
    })
    .catch((err) => {
      // console.error('resetPassword', err)
      store.commit(ADD_GLOBAL_MESSAGE, {
        type: 'danger',
        content: err.message
      })
    })
}

/**
 * Handle data request on User ref in firebase, which combined Get, Set methods.
 * @param {strong} action - 'set', 'get' the user data
 * @param {string[]} userInfo - required user info [uid, email] on 'set', and [uid, email=null] on 'get'
 */
export function handleUserData (action, ...userInfo) {
  const [uid, email] = userInfo
  const userRef = firebase.database().ref(`user/${uid}`)
  if (action === 'get') {
    return userRef.once('value')
      .then((snapshot) => snapshot.val())
      .catch((err) => {
        console.error(`handleUserData - ${action}: `, err)
      })
  } else if (action === 'set') {
    userRef.set({
      email,
      role: 'vendor',
      since: Date.now()
    }).catch((err) => {
      console.error(`handleUserData - ${action}: `, err)
    })
  } else {
    console.error('handleUserData: invalid params:action.')
  }
}

export function getDbRef (ref) {
  return firebase.database().ref(ref)
}

export function offDbRef (ref) {
  return firebase.database().ref(ref).off()
}

export function getDbTime () {
  return firebase.database.ServerValue.TIMESTAMP
}



// WEBPACK FOOTER //
// ./src/firebaseRef.js